import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyle, Button, ContainerButton, BoxButton } from "./style";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import classNames from 'classnames';
import { Wallet } from "config";
import { ReactComponent as ChatIcon } from "assets/images/brands/whatsapp.svg";
//import GenerateManifest from "./generate_manifest";
const pathname = "tracbel";
const currWallet = Wallet[pathname];
const theme = createMuiTheme({
  palette: {
    primary: {
      main: currWallet.color.primary,
    },
    secondary: {
      main: currWallet.color.secondary,
    },
  },
});

function App() {
  const [open, setOpen] = useState(true);
  //HANDLE WHATSAPP
  // const listFilial = [
  //   {value: "1", label: 'Tracbel Máquinas e Equipamentos (Todo Brasil)', token: '0cfc07a3272f65784fe2f9fac0029d70'},
  //   {value: "2", label: 'Tracbel Onibus e Caminhões (Norte)', token: 'aa27052adf8ce181978df5eb2df69ae4'},
  //   {value: "3", label: 'Tracbel Onibus e Caminhões ( Nordeste)', token: 'a7e072aea08a079323a4c9a6a52eb4b7'},
  // ]

  const handleSendWhatsapp = (phone) => {
    let link = document.createElement('a')
					link.href = ` https://wa.me//${phone}`
					link.target = '_blank'
					link.style.display = 'none'
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
  }

  const whatsappAvailable = [
    {label: 'Tracbel Máquinas e Equipamentos (Todo Brasil)', phone: "5508002001000" },
    {label: 'Tracbel Onibus e Caminhões (Norte)', phone: "5508002008880" },
    {label: 'Tracbel Onibus e Caminhões ( Nordeste)', phone: "558596688194" }
  ]

  useEffect(() => {
    //localStorage.clear()
    //GenerateManifest({...currWallet, pathname, url: window.location.href})
    //window.chtken = currWallet.token
    document.title = currWallet.name;
  }, []);


  const handleOpenWhatsapp = () => {
    setOpen(!open)
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />

      <ContainerButton>
       <BoxButton className={classNames({ hidden: open })}>
        <p>Olá cliente, com qual unidade você gostaria de falar?</p>
      {whatsappAvailable.map((whats) => (
        <Button
          style={{ border: "1px solid #fdba14" }}
          variant="contained"
          className={classNames({ hidden: open })}
          color="primary"
          onClick={() => handleSendWhatsapp(whats.phone)}
        >
          {whats.label}
          {/* <ChatIcon></ChatIcon>  */}
        </Button>
      ))}
      </BoxButton>
       <Button
          style={{ borderRadius: "0px 0px 10px 0px", padding: '0',minWidth: 'unset', width: "35px", height: "35px" }}
          variant="contained"
          classes={{ label: "button_chat" }}
          color="primary"
          onClick={() => handleOpenWhatsapp()}
        >
          <ChatIcon style={{ width: "17px", height: "17px", marginRight: "0px"}}></ChatIcon>
        </Button>
      </ContainerButton>
      {/* <>
      {!open ? (
        <Button
          variant="contained"
          classes={{ label: "button_chat" }}
          color="primary"
          onClick={() => setOpen(true)}
        >
          <ChatIcon></ChatIcon>
        </Button>
      ) : (
        <Container>
          <Header>
            <span />
            <img src={LogoWhite} alt="Logo" />
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Header>
          <Form
            pathname={pathname}
            wallet={currWallet}
            listFilial={listFilial}
            handleClose={() => setOpen(false)}
          />
        </Container>
      )}

      <ToastContainer
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      </> */}
    </ThemeProvider>
  );
}

export default App;
